import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { slideDrawer } from '../../reducers/UIReducer/UIActions';
import { IoIosArrowForward } from "react-icons/io";
import { isMobile, isTablet } from 'react-device-detect';
import useDataSuite from '../../AppMain/DataSuite/useDataSuite';
import FiltersWidget from '../Filters/FiltersWidget';
import { filtersDateRanges } from '../../config/constants';

const DataSuiteDetailsSlideDrawer = (props) => {
  const dispatch = useDispatch();
  const { fromDate, toDate, getDetailsData } = useDataSuite.useDataSuite();
  const enabled = useSelector(({ui}) => ui.datasuiteWidgetDetailsSlideDrawer);
  const widgetDetailsDrawerContents = useSelector(({datasuite}) => datasuite.widgetDetailsDrawer)
  const widgetName = widgetDetailsDrawerContents?.title;
  const [ resetKey, setResetKey ] = useState(0);

  const closeDetailsDrawer = () => {
    dispatch(slideDrawer.subtractDatasuiteDetails());
    setResetKey(prev => prev + 1);
    getDetailsData(props?.prechosenFilters, widgetName);
  };

  const getDrawerData = (selectedFilters) => {
    getDetailsData(selectedFilters, widgetName);
  };

  return (
    <div className={((isMobile &! isTablet) ? "ds-side-drawer-mobile" : "ds-side-drawer") + (enabled ? ' open' : '') + ' ' + props.className}>
      <div className='px-0' style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <Row className="m-3">
            <Col className="w-fc dflex text-size-24 ps-0">
                <IoIosArrowForward style={{color: 'black', position: 'relative'}} title='Hide Details Panel' className="clickable mb-1" onClick={() => closeDetailsDrawer()}></IoIosArrowForward>
            </Col>
            <Col className='ps-1 my-auto'>
                <div className="text-black main-header text-size-20">{widgetDetailsDrawerContents.title}</div>
            </Col>
        </Row>
        <Row className='w-100 ms-0'>
          <div style={{width: '100%', height: '1px', background: '#D7D8D9'}}></div>
        </Row>
        <div className='mb-2' id="dataSuiteDetailsDrawerFiltersCard">
          <FiltersWidget
            key={resetKey}
            minDate={fromDate}
            fromDate={fromDate}
            toDate={toDate}
            onApplyFilters={getDrawerData}
            dateRanges={filtersDateRanges}
            prechosenFilters={props?.prechosenFilters}
            saveFilterSetsEnabled={false}
            filterSetOptionsEnabled={true}
          />
        </div>
        <div className='me-0' style={{display: 'flex', flex: '1'}}>
          {widgetDetailsDrawerContents.drawerContents}
        </div>
      </div>
    </div>
  );
}

export default DataSuiteDetailsSlideDrawer;